import { render, staticRenderFns } from "./NewTelegramChannel.vue?vue&type=template&id=35a7f876&scoped=true"
import script from "./NewTelegramChannel.vue?vue&type=script&lang=js"
export * from "./NewTelegramChannel.vue?vue&type=script&lang=js"
import style0 from "./NewTelegramChannel.vue?vue&type=style&index=0&id=35a7f876&prod&lang=scss&scoped=true"
import style1 from "./NewTelegramChannel.vue?vue&type=style&index=1&id=35a7f876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a7f876",
  null
  
)

export default component.exports